/* eslint-disable */
import React, { useContext, useEffect, useRef, useState } from 'react';

const CallSecondLayout = ({ dynamicButtonDivs, dynamicDivs,handleMouseUpFunction }) => {
  
  return (
        <div
          id="SC80"
          stgId='STG2'
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            borderRadius: '10px',
            boxShadow: '0 0px 4px rgba(0, 0, 0, 0.1)', // Add a box shadow,
            
            
          }}
          dataMoveUpId='SC80'
          dataGroup='main'

        >
          
          <div
            id="SC80-B"
            style={{
              width: '100%',
              flex: 0.4,
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
            stgId='STG2'
            dataMoveUpId='SC80'
            onMouseUp={e=>handleMouseUpFunction(e)}
            dataGroup='header'
          >
            
          </div>
          <div
            id="SC80-C"
            style={{
              width: '100%',
              display: 'grid',
              overflow: 'auto',
              flex: 5
            }}
            stgId='STG2'
            onMouseUp={e=>handleMouseUpFunction(e)}
            dataMoveUpId='SC80'
            dataGroup='contentWrapper'
          >
            
          </div>
        </div>
 
  );
};

export default CallSecondLayout;